import Avatar from '@mui/material/Avatar'
import { styled } from '@mui/material/styles'

export const StyledAvatar = styled(Avatar)({
  width: 24,
  height: 24,
})
